import { YourNetwork } from '.';

export type ResponseListState = {
  loaded: boolean;
  loading: boolean;
  surveys: FormResponse[];
};

export type FormResponse = {
  id: string;
  surveyId: string;
  email: string;
  createdOn: string;
  updatedOn: string | null;
  createdBy: string;
  sentOn: string;
  viewedOn: string;
  completedOn: string | null;
  info: {
    name: string;
    cleanName: string | null;
    email: string;
    role: string;
    organization: string;
    cleanOrganization: string | null;
    organizationType: number | null;
    cleanOrganizationType: number | null;
    zipCode: string;
    participationInNetworkType: number | null;
  };
  network: {
    yourNetwork: YourNetwork[];
  };
};

export type SendInviteStatus = 'sent' | 'alreadyInvited' | 'failed';

export type SendInviteResponse = {
  status: SendInviteStatus;
  response: FormResponse;
};

export type ReadableFormDates = {
  sentOn: string;
  viewedOn: string;
  completedOn: string;
};

export function getReadableFormDates(response: FormResponse): ReadableFormDates {
  return {
    sentOn: response.sentOn ? new Date(response.sentOn).toLocaleDateString() : 'N/A',
    viewedOn: response.viewedOn ? new Date(response.viewedOn).toLocaleDateString() : 'Not Viewed',
    completedOn: response.completedOn ? new Date(response.completedOn).toLocaleDateString() : 'Not Completed'
  };
}
